var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.metadataKey` well-known symbol
// https://github.com/tc39/proposal-decorator-metadata
defineWellKnownSymbol('metadataKey');